import { render } from "./Container.vue?vue&type=template&id=2d73ea82&scoped=true"
import script from "./Container.vue?vue&type=script&lang=js"
export * from "./Container.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-2d73ea82"

export default script